var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cost-statistics-skeleton"},[_c('span',{staticClass:"skeleton-loader-shimmer cost-statistics-skeleton__inner"})])
}]

export { render, staticRenderFns }